import * as React from 'react';
import { loadModules } from 'esri-loader';

export default class Fullscreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullscreen: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules(['esri/widgets/Fullscreen']).then(([ Fullscreen ]) => {
            let fullscreen = new Fullscreen({
                view: this.props.view,
            });
            this.setState({ fullscreen });
            this.props.view.ui.add(fullscreen, 'top-left');
        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.view.ui.remove(this.state.fullscreen);
    }
}
